var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"car-class-row"},[_c('td',[_vm._v("\n    "+_vm._s(_vm.carClass.name)+"\n  ")]),_vm._v(" "),_c('td',[_vm._v("\n    "+_vm._s(_vm.carClass.CarTypes.length)+"\n  ")]),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":{ path: ("/fleet/vehicles/classes/edit/" + (_vm.carClass.uuid)) }}},[_c('span',{staticClass:"fa fa-edit fa-fw"}),_vm._v(" Edit\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e28c036","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rows/CarClass.vue
// module id = 1013
// module chunks = 1